import React, { Fragment, useState } from "react";
import { GenericTextArea } from "../../../components/generic/GenericTextFields";
import { EditProfileButtons } from "./EditProfileButtons";
import { useFormik } from "formik";
import { object, string } from "yup";
import { createOrUpdateUserDetails } from "../../../config/apisauce";
import { VERIFY_FACE_ID_KEY } from "../../../enums/profileSetupEnums";
import useNotiStack from "../../../hooks/useNotiStack";

export const EditAboutMe = ({ refetchDetails, handleClose, creatorDetails }) => {
  const { success } = useNotiStack();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);
    const params = {
      ...values,
      user_id: creatorDetails?.user_id,
      current_step: VERIFY_FACE_ID_KEY
    }
    const response = await createOrUpdateUserDetails(params);
    if (response.ok) {
      success('Successfully updated about me!');
      refetchDetails();
      handleClose();
    }
    setLoading(false);
  };

  const formik = useFormik({
    initialValues: { bio: creatorDetails?.bio },
    enableReinitialize: true,
    validationSchema: object().shape({
      bio: string()
        .required("This field cannot be empty")
        .min(100, "Bio must be at least 100 characters long")
        .max(1000, "Bio cannot exceed 1000 characters"),
    }),
    onSubmit: (values) => handleSubmit(values)
  });

  return (
    <Fragment>
      <GenericTextArea
        rows={13}
        placeholder={'Tell us something about yourself...'}
        value={formik?.values?.bio}
        handleChange={(value) => formik.setFieldValue('bio', value)}
        error={Boolean(formik?.errors?.bio)}
        helperText={formik?.errors?.bio}
      />
      <EditProfileButtons
        handCancel={() => handleClose()}
        handleSubmit={() => formik?.handleSubmit()}
        loading={loading}
      />
    </Fragment>
  );
};